import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../../../../vista-usuario/vista-usuario.state';
import { ROUTE_ANIMATIONS_ELEMENTS } from 'projects/registro-personas-empresas/src/app/core/core.module';
import { ViveroGrupoEspecie } from '../../entity-viveros-grupo-especie.model';
import { entityViverosGrupoEspecieDeleteRequest } from '../../entity-viveros-grupo-especie.actions';
import { IBaseTable } from 'projects/registro-personas-empresas/src/app/shared/util/base-table.util';
import { MatDialog } from '@angular/material/dialog';
import { RegistroActividadViveroFormContainerComponent } from '../registro-actividad-vivero-form-container/registro-actividad-vivero-form-container.component';
import { ViveroFormInput } from '../../models/entity-viveros-grupo-especie.models';
import { FormActionType } from '@rpe/registro-personas-empresas-lib';
import { ConfirmDialogComponent } from 'projects/registro-personas-empresas/src/app/shared/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'rpe-registro-actividad-viveros-form',
  templateUrl: './registro-actividad-viveros-form.component.html',
  styleUrls: ['./registro-actividad-viveros-form.component.scss']
})
export class RegistroActividadViverosFormComponent {
  initial: boolean = false;

  @Input() set actividadViverosFormInput({
    vivero,
    edit
  }: {
    vivero: ViveroFormInput[];
    edit: boolean;
  }) {
    this.baseTableOptions = {
      ...this.baseTableOptions,
      dataSource: vivero.map((vivero) => {
        return vivero.vivero;
      })
    };

    if (vivero.length === 0 && !edit && !this.initial) {
      this.onAdd();
    }

    this.initial = true;
  }

  @Output() showEvent: EventEmitter<boolean> = new EventEmitter<boolean>(false);

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  baseTableOptions: IBaseTable<ViveroGrupoEspecie> = {
    dataSource: [],
    columns: [
      {
        caption: 'Número',
        field: {
          key: 'id'
        }
      },
      {
        caption: 'Nombre',
        field: {
          key: 'nombre'
        }
      }
    ],
    actions: [
      {
        name: 'Editar',
        icon: '',
        hide: () => {
          return true;
        },
        action: (element: ViveroGrupoEspecie) => {
          this.dialog.open(RegistroActividadViveroFormContainerComponent, {
            data: {
              vivero: element,
              type: FormActionType.Update
            },
            height: '90vh',
            width: '900px'
          });
        }
      },
      {
        name: 'Borrar',
        icon: '',
        hide: () => {
          return true;
        },
        action: ($event: ViveroGrupoEspecie) => {
          this.deleteDeposito($event);
        }
      }
    ]
  };

  constructor(private dialog: MatDialog, private store: Store<State>) {}

  onCancel() {
    this.showEvent.emit(false);
  }

  deleteDeposito($event: ViveroGrupoEspecie): void {
    const ref = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Eliminar vivero',
        contentText: `¿Está seguro que desea eliminar el vivero?`,
        submitText: 'Eliminar',
        cancelText: 'Cancelar',
        cancelColor: 'primary'
      }
    });

    ref.afterClosed().subscribe((result) => {
      if (result) {
        this.store.dispatch(
          entityViverosGrupoEspecieDeleteRequest({
            item: $event
          })
        );
      }
    });
  }

  onAdd() {
    this.dialog.open(RegistroActividadViveroFormContainerComponent, {
      data: {
        vivero: null,
        type: FormActionType.Add
      },
      height: '90vh',
      width: '900px'
    });
  }
}
